import React, { useState, useMemo, useEffect, useRef } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import parse from "html-react-parser";
import { CoIBooks, ContemporaryRomance, KotRBooks, PPBooks } from "../Components/Books";
import "../CSS_stuff/book_pages_format.css";
import ShopifyBuy from '@shopify/buy-button-js'            // side-effect: adds UI to ShopifyBuy

//const KOTR_KICKSTARTER_URL = "https://www.kickstarter.com/projects/mangala-knightess/knightess-of-the-realm-spicy-epic-dragon-romantasy-series-0?ref=5n3dxl";

const BookPage = () => {
  // ─── React Hooks at the very top ───────────────────────
  const { state } = useLocation();
  const { id }    = useParams();
  const [backErrored, setBackErrored] = useState(false);
  const initDone = useRef(false);

  const allBooks = useMemo(
    () => [...CoIBooks, ...KotRBooks, ...PPBooks, ...ContemporaryRomance],
    []
  );

  const book = state?.book || allBooks.find(b => b.link === id);

  // detect if this book belongs to the KotR collection
  const isKotR = Boolean(book && KotRBooks.some(k => k.link === book.link));

  const navigate = useNavigate();

// find prev/next using allBooks order
const currentIndex = allBooks.findIndex(b => b.link === book.link);
const prevBook = currentIndex > 0 ? allBooks[currentIndex - 1] : null;
const nextBook = currentIndex >= 0 && currentIndex < allBooks.length - 1 ? allBooks[currentIndex + 1] : null;

const goPrev = () => {
  if (!prevBook) return;
  navigate(`/books/${prevBook.link}`, { state: { book: prevBook } });
};

const goNext = () => {
  if (!nextBook) return;
  navigate(`/books/${nextBook.link}`, { state: { book: nextBook } });
};

  // this defines ShopifyBuy for the shopify button
  window.ShopifyBuy = ShopifyBuy

  useEffect(() => {
    // If the book is part of KotR we do NOT initialize Shopify buy button for it.
    if (!book?.shopifyProductId || initDone.current) return;
    initDone.current = true;

    const containerId = `product-component-${book.shopifyComponentId}`;
    const scriptURL  = "https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js";

    function initBuyButton() {
      if (window.ShopifyBuy && window.ShopifyBuy.UI) {
        return setupUI();
      }
      loadScript();
    }

    function loadScript() {
      const script = document.createElement("script");
      script.async = true;
      script.src   = scriptURL;
      script.onload = setupUI;
      document.head.appendChild(script);
    }

    function setupUI() {
      const client = ShopifyBuy.buildClient({
        domain: '5y5enc-1u.myshopify.com',
        storefrontAccessToken: 'ab137836cd855db1de74acee35f862f5',
      });
      ShopifyBuy.UI.onReady(client).then((ui) => {
        ui.createComponent("product", {
          id: book.shopifyProductId,
          node: document.getElementById(containerId),
          moneyFormat: "%24%7B%7Bamount%7D%7D",
          options: {
          "product": {
            "styles": {
              "product": {
                "@media (min-width: 601px)": {
                  "max-width": "calc(25% - 20px)",
                  "margin-left": "20px",
                  "margin-bottom": "50px"
                },
                "carousel-button": {
                  "display": "none"
                }
              },
              "button": {
                "font-size": "18px",
                "padding-top": "17px",
                "padding-bottom": "17px",
                "color": "#6f0999",
                ":hover": {
                  "color": "#6f0999",
                  "background-color": "#e6be1d"
                },
                "background-color": "#ffd320",
                ":focus": {
                  "background-color": "#e6be1d"
                },
                "border-radius": "30px"
              },
              "quantityInput": {
                "font-size": "18px",
                "padding-top": "17px",
                "padding-bottom": "17px"
              },
              "price": {
                "font-size": "26px"
              },
              "compareAt": {
                "font-size": "22.099999999999998px"
              },
              "unitPrice": {
                "font-size": "22.099999999999998px"
              }
            },
            "contents": {
              "img": false,
              "imgWithCarousel": false
            },
            "text": {
              "button": "Add eBook to cart"
            }
          },
          "productSet": {
            "styles": {
              "products": {
                "@media (min-width: 601px)": {
                  "margin-left": "-20px"
                }
              }
            }
          },
          "modalProduct": {
            "contents": {
              "img": false,
              "imgWithCarousel": true,
              "button": false,
              "buttonWithQuantity": true
            },
            "styles": {
              "product": {
                "@media (min-width: 601px)": {
                  "max-width": "100%",
                  "margin-left": "0px",
                  "margin-bottom": "0px"
                }
              },
              "button": {
                "font-size": "18px",
                "padding-top": "17px",
                "padding-bottom": "17px",
                "color": "#6f0999",
                ":hover": {
                  "color": "#6f0999",
                  "background-color": "#e6be1d"
                },
                "background-color": "#ffd320",
                ":focus": {
                  "background-color": "#e6be1d"
                },
                "border-radius": "30px"
              },
              "quantityInput": {
                "font-size": "18px",
                "padding-top": "17px",
                "padding-bottom": "17px"
              },
              "price": {
                "font-family": "Helvetica Neue, sans-serif",
                "font-weight": "normal",
                "font-size": "18px",
                "color": "#4c4c4c"
              },
              "compareAt": {
                "font-family": "Helvetica Neue, sans-serif",
                "font-weight": "normal",
                "font-size": "15.299999999999999px",
                "color": "#4c4c4c"
              },
              "unitPrice": {
                "font-family": "Helvetica Neue, sans-serif",
                "font-weight": "normal",
                "font-size": "15.299999999999999px",
                "color": "#4c4c4c"
              }
            },
            "text": {
              "button": "Add to cart"
            }
          },
          "option": {},
          "cart": {
            "styles": {
              "button": {
                "font-size": "18px",
                "padding-top": "17px",
                "padding-bottom": "17px",
                "color": "#6f0999",
                ":hover": {
                  "color": "#6f0999",
                  "background-color": "#e6be1d"
                },
                "background-color": "#ffd320",
                ":focus": {
                  "background-color": "#e6be1d"
                },
                "border-radius": "30px"
              }
            },
            "text": {
              "total": "Subtotal",
              "button": "Checkout"
            }
          },
          "toggle": {
            "styles": {
              "toggle": {
                "background-color": "#ffd320",
                ":hover": {
                  "background-color": "#e6be1d"
                },
                ":focus": {
                  "background-color": "#e6be1d"
                }
              },
              "count": {
                "font-size": "18px",
                "color": "#6f0999",
                ":hover": {
                  "color": "#6f0999"
                }
              },
              "iconPath": {
                "fill": "#6f0999"
              }
            }
            }
          }
        },
              );
            });
          }

    if (window.ShopifyBuy && window.ShopifyBuy.UI) {
      initBuyButton();
    } else {
      const s = document.createElement("script");
      s.src    = scriptURL;
      s.async  = true;
      s.onload = initBuyButton;
      document.head.appendChild(s);
    }
  }, [book, isKotR])

   // Ensure the viewport is at the top when navigating to a book page
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [book]); // run on mount and when the displayed book changes

  // ─── Early return if no book found ────────────────────
  if (!book) {
    return <h2>Book not found: {id}</h2>;
  }

  // ─── Back‐cover fallback logic ─────────────────────────
  let backSrc = null;
  if (book.backimage) {
    try {
      backSrc = require(`../assets/${book.backimage}`);
    } catch {
      backSrc = book.backimage;
    }
  }
  const showBackImage = backSrc && !backErrored;

  return (
    <div className="book-detail-container">
      {/* render the book's tagline (if present) where the placeholder was */}
      <div className="book-link">
        {book?.booktagline ? (
          <div className="book-tagline">
            {parse(book.booktagline)}
          </div>
        ) : null}
      </div>

      <div className="book-layout">
        <div className="book-image-wrapper">
          <img
            className="book-cover"
            src={book.image}
            alt={`${parse(book.title)} cover`}
            loading="lazy"
          />
        </div>

                <div className="book-actions">
          {book.shopifyProductId ? (
            <div className="shopify-container">
              <div id={`product-component-${book.shopifyComponentId}`}></div>
            </div>
          ) : (
            <p>The buy button is not working at the moment</p>
          )}
        </div>

        {/* back cover / back blurb wrapper
            add a modifier class when showing the back-blurb so CSS can enlarge it */}
        <div className={`book-image-wrapper ${showBackImage ? "" : "backblurb-wrapper"}`}>
          {showBackImage ? (
            <img
              className="book-cover"
              src={backSrc}
              alt={parse(book.backblurb) || parse(book.title)}
              loading="lazy"
              onError={() => setBackErrored(true)}
            />
          ) : (
            <div className="backblurb-box">
              {parse(book.backblurb) || "No back blurb available."}
            </div>
          )}
        </div>
      </div>

      {book.Description && (
        <section className="book-description">
          
          <h2 className="description-title">
            {parse(book.DescriptionTitle)}
          </h2>
          {book.DescriptionSubTitle && (
            <h3 className="description-subtitle">
              {parse(book.DescriptionSubTitle)}
            </h3>
          )}
          <p className="description-text">
            {parse(book.Description)}
          </p>
        </section>
      )}

      {/* Previous / Next navigation */}
      <div className="book-nav" style={{ display: "flex", justifyContent: "space-between", marginTop: 20 }}>
        <button
          type="button"
          onClick={goPrev}
          disabled={!prevBook}
          aria-label={prevBook ? `Previous: ${prevBook.title}` : "No previous book"}
          style={{ padding: "8px 14px", borderRadius: 6, cursor: prevBook ? "pointer" : "not-allowed" }}
        >
          ← Previous
        </button>

        <button
          type="button"
          onClick={goNext}
          disabled={!nextBook}
          aria-label={nextBook ? `Next: ${nextBook.title}` : "No next book"}
          style={{ padding: "8px 14px", borderRadius: 6, cursor: nextBook ? "pointer" : "not-allowed" }}
        >
          Next →
        </button>
      </div>
    </div>
  );
};

export default BookPage;